(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name AppController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('AppController', AppController);

    AppController.$inject = ["OfertaService","GeneralService","UserService","$timeout"];

    function AppController(OfertaService,GeneralService,UserService,$timeout)
    {

        var vm = this;
        vm.generalService = GeneralService;
        vm.step = 1;
        vm.errorprecio = false;
        vm.errorcondiciones = false;
        vm.loading = false;
        vm.contador = 0;

        vm.formatearMiles = function() {
            if (vm.precio) {
                // Eliminar todos los caracteres que no sean números o comas (también eliminamos los espacios)
                let valor = vm.precio.replace(/[^\d,]/g, ''); // Esto eliminará los espacios y cualquier otro carácter no numérico

                // Si hay más de una coma, reemplazamos todas las comas excepto la última
                let partes = valor.split(',');
                if (partes.length > 2) {
                    valor = partes[0] + ',' + partes.slice(1).join('');
                }

                // Convertir la coma en punto para trabajar con el separador decimal
                valor = valor.replace(',', '.');

                // Limitar a 2 decimales si hay parte decimal
                let partesDecimal = valor.split('.');
                if (partesDecimal.length > 1) {
                    partesDecimal[1] = partesDecimal[1].substring(0, 2);  // Solo 2 decimales
                    valor = partesDecimal[0] + '.' + partesDecimal[1];
                }

                // Agregar puntos a la parte entera para separar los miles
                let parteEntera = valor.split('.')[0]; // Parte entera antes del punto
                let parteDecimal = partesDecimal.length > 1 ? ',' + partesDecimal[1] : ''; // Parte decimal con coma
                
                // Formatear la parte entera con puntos cada tres dígitos
                let parteEnteraFormateada = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

                // Unir la parte entera y la parte decimal
                vm.precio = parteEnteraFormateada + parteDecimal;
            }
        };



        vm.calcularPrecioConIncremento = function() {
            if (!vm.precio) return { precioFinal: "0.00", tipoComision: "Sin comisión" };  // Si no hay precio, retorna "0.00"

            // Eliminar puntos para convertir correctamente el precio a un número, y convertir la coma en punto
            let precioSinPuntos = parseFloat(vm.precio.replace(/\./g, '').replace(',', '.'));  // Eliminar puntos y convertir coma en punto

            let precioConComision;
            let tipoComision;

            if (precioSinPuntos >= 1 && precioSinPuntos <= 30000) {
                // De 1 a 30,000: Comisión fija de 1,500
                precioConComision = precioSinPuntos + 1500;
                tipoComision = "1,500 €";
            } else if (precioSinPuntos > 30000 && precioSinPuntos <= 60000) {
                // De 30,001 a 60,000: Comisión fija de 3,000
                precioConComision = precioSinPuntos + 3000;
                tipoComision = "3,000 €";
            } else if (precioSinPuntos > 60000 && precioSinPuntos <= 1500000) {
                // De 60,001 a 1,500,000: Comisión del 5%
                precioConComision = precioSinPuntos * 1.05;
                tipoComision = "5%";
            } else if (precioSinPuntos > 1500000) {
                // Más de 1,500,000: Comisión del 3.5%
                precioConComision = precioSinPuntos * 1.035;
                tipoComision = "3.5%";
            } else {
                // Manejar cualquier otro caso que no esté cubierto
                precioConComision = precioSinPuntos;
                tipoComision = "Sin comisión";
            }

            let precioConComisionRedondeado = precioConComision.toFixed(2);

            // Dividir el número en parte entera y parte decimal
            let partes = precioConComisionRedondeado.split('.');  // Separar parte entera y decimal
            let parteEntera = partes[0];
            let parteDecimal = partes[1];

            // Formatear la parte entera con puntos para los miles
            parteEntera = parteEntera.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

            // Unir parte entera con parte decimal usando coma como separador decimal
            let precioFinalFormateado = parteEntera + ',' + parteDecimal;

            return {
                precioFinal: precioFinalFormateado,
                tipoComision: tipoComision
            };
        };


        vm.realizaroferta = function(form){
             if (vm.precio) {
                let resultado = vm.calcularPrecioConIncremento();
                vm.precio = resultado.precioFinal;
            }
            if (vm.loading) {
               return;
            }
            if(form.$valid){
                vm.loading = true;
            }
            OfertaService.Ofertaform(vm).then(function(data){
                  vm.loading = false;
                  vm.precio = vm.calcularPrecioConIncremento();
                  console.log(data)
                  vm.nuevaoferta = data.nuevaoferta;
          
               })

           
      	}

        

      	vm.nextStep = function(step){

            console.log(step);
            if (vm.step == 1 && vm.precio && step == 1) {
                console.log(vm.precio);
                vm.step++;
            }else{
      	        vm.errorprecio = true;
            }

            if (vm.step == 2 && step == 2) {
                vm.step++;
            }

            // if (vm.step == 2 && !vm.condiciones && step == 2) {
            //     vm.errorcondiciones = true;
            // }


      	}

      	vm.prevStep = function(){
      		vm.step = vm.step -1;
      	}

        vm.realizarSolicitud = function(form){
            if (vm.loading) {
               return;
            }
            if(form.$valid){
                vm.loading = true;
            }
            UserService.Solicitudform(vm).then(function(data){
                  vm.loading = false;
                  vm.nuevasolicitud = data.nuevasolicitud;
               })
        }




    }


})();